import { o_util } from "../../common/namespaces";
import { assignNamespace } from "../../common/namespace-utils";
import { deprecated } from "../../common/logger";
import { isEmptyObject, isPlainObject } from "./head/object";
import { serialize, serializeForm, deserialize, coerce } from "./head/serialize";
import { withMacrotask, withRenderSlice } from "./head/promise";
import { nexus } from "../../exports/nexus";

export { isEmptyObject, isPlainObject } from "./head/object";

export { serialize, serializeForm, deserialize, coerce };
export type { Serializable } from "./head/serialize";

export { withMacrotask, withRenderSlice };

const { runWithAnimationFrame, runWithRenderSlice, runWithMacrotask, runWithMicrotask } =
  nexus().grcore;

const message = "Use navigation module instead.";
const mod = "core";

assignNamespace(
  o_util,
  mod,
  {
    isEmptyObject,
    isPlainObject,

    /*         */
    withMacrotask,
    withRenderSlice,

    /*            */
    coerce: deprecated(coerce, mod, "coerce", message),
    deserialize: deprecated(deserialize, mod, "deserialize", message),
    serialize: deprecated(serialize, mod, "serialize", message),
    serializeForm: deprecated(serializeForm, mod, "serializeForm", message),
  },
  {
    runWithMicrotask,
    runWithMacrotask,
    runWithRenderSlice,
    runWithAnimationFrame,
  },
);
